import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.467",
      d: "M16.675 13.202v5.14M3.92 22.97c-1.186 2.056.298 4.626 2.672 4.626h20.163c2.374 0 3.858-2.57 2.672-4.626L19.346 5.495c-1.187-2.057-4.156-2.057-5.343 0zm12.754-.515h.01v.01h-.01z"
    }, null, -1)
  ])))
}
export default { render: render }